module.exports = __webpack_public_path__ + "static/media/money-icon.d7adac28.svg";